import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReplayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"replay"}/>
}
